import axios from "axios";
import { Base_URL } from "../url";

export const saveItemGroup2 = async (itemGroupData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/ItemGroup2/CreateItemGroup2?UserName=${userId}`,
      itemGroupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving item group 2 details!";
  }
};

export const getAllItemGroups = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ItemGroupMaster/GetAllItemGroups`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching item groups!";
  }
};

export const getItemGroups1ByItemGroupCode = async (itemGroupCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup1/GetItemGroupsByItemGroupCode`,
      { itemGroupCode }
    );
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching item groups 1!";
  }
};